/*
 * 運営操作の並び。
 *
 * 広いとき: [無効化][調整][取り消し]  [削除] ……… [開始]
 * 狭いとき: [無効化][調整][取り消し]
 *           [削除] ……………………………… [開始]
 *
 * 成り行きで折り返すと、削除だけが字下げされたり開始が単独の段に落ちたりして、
 * 並びの意味（左は卓に手を入れる操作、右はハンドを進める操作）が崩れる。改行位置を
 * 決めておき、パネル自身の幅で切り替える（コンテナクエリ）。
 */

.panel {
  container-type: inline-size;
}

.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--mantine-spacing-sm);
}

/* 広いときは幅を持たない。 */
.break {
  width: 0;
}

/* 削除は取り消しから間隔を空ける。誤って押しうる位置に置かない。 */
.close {
  margin-inline-start: var(--mantine-spacing-xl);
}

/* 開始ボタンを右端へ押し出す。 */
.spacer {
  flex: 1;
}

@container (max-width: 54rem) {
  .break {
    flex-basis: 100%;
    height: 0;
  }

  .close {
    margin-inline-start: 0;
  }
}
